module.exports = __webpack_public_path__ + "img/schema_API.ab67e40d.jpg";